import gql from 'graphql-tag';

export const CHECK_TMP_COMPANION_TOKEN = gql`
    query(
        $cid: String
        $member_no: String!
    ){
        checkTmpCompanionToken(
            cid: $cid
            member_no: $member_no
    ){
        resultCode
        representativeName
        info
    }
}
`;

export const APPROVAL_COMPANION_RESERVE = gql`
    mutation(
        $cid: String
        $member_no: String!
    ){
        approvalCompanionReserve(
            cid: $cid
            member_no: $member_no
        ){
            result
        }
    }
`;

export const DELETE_TMP_COMPANION_RESERVE = gql`
    mutation($cid: String!){
        deleteTmpCompanionReserve(cid: $cid){
            result
        }
    }
`;
